<template>
  <el-cascader
    v-model="selectedValue"
    v-bind="$attrs"
    :disabled="computedDisabled"
    :clearable="computedDisabled ? false : computedClearable"
    :placeholder="computedSelectPlaceholder"
    :clear-icon-right="clearIconRight"
    :popper-height="popperHeight"
    v-on="$listeners"
    @change="change"
    @blur="blur"
    @focus="focus"
  >
  </el-cascader>
</template>

<script>
import ElCascader from 'vue-xpc/src/element-ui/packages/cascader';
import Placeholder from '../form/placeholder.js';

export default {
  name: 'RtCascader',
  components: {
    ElCascader
  },
  mixins: [Placeholder],
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 清除
    clearable: {
      type: Boolean,
      default: undefined,
      required: false
    },
    // 自定义清空按钮位置
    clearIconRight: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      required: false
    },
    popperHeight: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      selectedValue: this.value
    };
  },
  inject: {
    elForm: {
      default: ''
    }
  },
  computed: {
    computedClearable () {
      return this.clearable === undefined ? this.elForm && this.elForm.$attrs && this.elForm.$attrs['all-clearable'] : this.clearable
    },
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val);
    },
    blur (event) {
      this.$emit('blur', event);
    },
    focus (event) {
      this.$emit('focus', event);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCascader.vue?241c49e9